import React, { useCallback, useState } from 'react'
import { Link, Loader2 } from 'lucide-react'

import { Icon } from '../../features/ui/Icon.js'
import { Surface } from '../../features/ui/Surface.js'
import i18next from 'i18next'
import { Button } from '../../features/ui/Button/Button.js'

export type LinkPreviewEditorPanelProps = {
  initialSrc?: string
  initialOpenInNewTab?: boolean
  onSetLink: (src: string) => void
  isLoading?: boolean
}

export const useLinkEditorState = ({ initialSrc, onSetLink }: LinkPreviewEditorPanelProps) => {
  const [url, setUrl] = useState(initialSrc || '')

  const onChange = useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setUrl(event.target.value)
  }, [])

  // const isValidUrl = useMemo(() => /^(\S+):(\/\/)?\S+$/.test(url), [url]);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault()
      // if (isValidUrl) {
      onSetLink(url)
      // }
    },
    [url, onSetLink],
  )

  return {
    url,
    setUrl,
    onChange,
    handleSubmit,
  }
}

export const LinkPreviewEditorPanel = ({
  onSetLink,
  initialOpenInNewTab,
  initialSrc,
  isLoading = false,
}: LinkPreviewEditorPanelProps) => {
  const state = useLinkEditorState({
    onSetLink,
    initialOpenInNewTab,
    initialSrc,
  })

  return (
    <Surface className='p-2'>
      <div className='flex items-center gap-2'>
        <label className='flex items-center gap-2 p-2 rounded-lg bg-neutral-100 dark:bg-neutral-900 cursor-text'>
          <Icon icon={Link} className='flex-none text-black dark:text-white' />
          <textarea
            className='flex-1 bg-transparent outline-none min-w-[16rem] min-h-[200px] text-black text-sm dark:text-white'
            placeholder={i18next.t('enterEmbedCode') || 'Enter Embed Code'}
            value={state.url}
            onChange={state.onChange}
            disabled={isLoading}
          />
        </label>
        <Button
          variant='primary'
          buttonSize='small'
          type='button'
          onClick={(e) => {
            state.handleSubmit(e)
          }}
          disabled={isLoading}
        >
          {isLoading ? (
            <div className='flex items-center gap-2 text-sm text-neutral-600 dark:text-neutral-400'>
              <Loader2 className='w-4 h-4 animate-spin' />
              <span>{i18next.t('loading') || 'Loading'}</span>
            </div>
          ) : (
            <>{i18next.t('setLink') || 'Set Link'}</>
          )}
        </Button>
      </div>
    </Surface>
  )
}
